import React, { Component } from 'react'
import {Button,Icon} from 'antd';

class NotFound extends Component {
    render() {
        return(
            <div id="explain">
                <div className="explain-box">
                    <div className="explain-box-left">
                        <Icon className="explain-icon" type="exclamation-circle-o" />
                    </div>
                    <div className="explain_box-right">
                        <h3>404 NOT FOUND</h3>
                        <p>該当するページが見つかりません</p>
                        <Button type="primary" className="button" onClick={()=>{window.location.href=("/")}}>
                            トップへ
                        </Button>
                    </div>
                </div>
            </div>
        )
    }
}

export default NotFound


// WEBPACK FOOTER //
// ./src/components/NotFound.js